/*global SunergoPlatform*/

import dayjs from 'dayjs';
import flatpickr from 'flatpickr';

/**
 * Initialize Flatpickr date pickers.
 */
const initDatePickers = function() {
	const datePickers = document.querySelectorAll('[data-datepicker]');
	if (!datePickers || datePickers.length < 1) return;

	let hasClearFieldAction = false;

	/**
	 * Initialize the Flatpickr field.
	 * @param {object} dp - the date picker input.
	 */
	function initFlatpickr(dp) {
		const options = JSON.parse(JSON.stringify(dp.dataset));
		options.altInput = true;
		options.dateFormat = 'Y-m-d';
		options.altFormat = 'M j, Y';
		options.monthSelectorType = 'dropdown';

		if (options.enableTime) {
			options.dateFormat += ' H:i:S';
			options.altFormat += ' h:i K';
		}

		if (options.noCalendar) {
			options.dateFormat = 'H:i:S';
			options.altFormat = 'h:i K';
		}

		if (!options.inline) {
			options.appendTo = dp.closest('.sp-field__input-wrapper');
			options.static = true;
		}

		if (options.disable) options.disable = JSON.parse(options.disable);
		if (options.enable) options.enable = JSON.parse(options.enable);

		/**
		 * Use DayJS to convert date strings into something useable in Flatpickr.
		 * @param {*} dateString - the date string, regardless of format.
		 * @returns the string as a JS Date.
		 */
		options.parseDate = function(dateString) {
			let date = dayjs(dateString);
			return date.toDate();
		};

		// If Flatpickr allows multiple dates or a date range, default date is an array.
		if (dp.dataset.startDate && (options.mode == 'multiple' || options.mode == 'range')) {
			const defaultDate = [];
			defaultDate.push(dp.dataset.startDate);
			if (dp.dataset.endDate) defaultDate.push(dp.dataset.endDate);
			options.defaultDate = defaultDate;
		}
		flatpickr(dp, options);

		// Setup clear field action.
		if (dp.dataset.clearFieldAction) {
			const clearAction = dp.closest('[data-field-id]').querySelector(`[data-target-field='${dp.id}']`);
			if (clearAction) hasClearFieldAction = true;
		}
	}

	datePickers.forEach(function(item) {
		initFlatpickr(item);
	});

	if (hasClearFieldAction) {
		SunergoPlatform.actionButtons.addAction(function(action, button) {
			if (action != 'clear-field-flatpickr') return false;
			const fieldId = button.dataset.targetField;
			const field = document.getElementById(fieldId);
			const fp = field._flatpickr;
			if (field && fp) fp.clear();
			return true;
		});
	}
};

export default initDatePickers;